import React from 'react';
import { type ILayerProps, type ITextLayerProps } from '@/version-types';
import { getComputedStrokes } from '../../utils';

type Props = {
    href: string;
    layer: ILayerProps;
};

export const GlowUse: React.FC<Props> = ({ href, layer }) => {
    const { textGlow = [], textStroke = [] } = layer.data as ITextLayerProps;
    const glow = textGlow.length > 0 ? textGlow[0] : null;
    const strokes = getComputedStrokes(textStroke);

    if (!glow || glow.hidden) return null;

    const growWidth =
        (strokes.length > 0 ? strokes.reduce((pre, cur) => pre + (cur.hidden ? 0 : cur.width), 0) : 0) +
        Math.ceil(glow.width * 0.5);

    return (
        <use
            xlinkHref={href}
            fill="transparent"
            stroke={glow.color}
            strokeLinejoin="round"
            strokeWidth={growWidth}
            filter={`blur(${Math.max(glow.width * 0.8, 2)}px)`}
        />
    );
};
